import type { SimulatorField } from '@vedalib/editor/lib/elements'
import { useState } from 'react'

import AbsolutePortal from 'components/Editor/components/AbsolutePortal'
import Button, { IconButton } from 'components/uiKit/Button'
import Dropdown from 'components/uiKit/Dropdown'
import Tooltip from 'components/uiKit/Dropdown/Tooltip'
import { KitSize } from 'components/uiKit/KitTypes'
import { t } from 'services/Translation'

import DecoratorSettings from './DecoratorSettings'
import * as s from './InputFieldToolbar.module.scss'
import ValidationSettings from './ValidationSettings'

interface IInputFieldToolbarProps {
  field: SimulatorField
  onDeleteField: () => void
  onUpdateField: (values: Partial<SimulatorField>) => void
}

const InputFieldToolbar = ({ field, onDeleteField, onUpdateField }: IInputFieldToolbarProps) => {
  const [showDecoratorSettings, setShowDecoratorSettings] = useState(false)
  const [showValidationSettings, setShowValidationSettings] = useState(false)

  return (
    <AbsolutePortal
      name='inputFieldOptions'
      offset='8px 0'
      placement='bottomLeft'
      recalculatingKey={[field.x, field.y, field.width, field.height].join('-')}
      zIndex={1}
    >
      <div className={s.buttons} onClick={(e) => e.stopPropagation()}>
        <Dropdown
          offset={[12, -6]}
          onVisibleChange={setShowDecoratorSettings}
          overlay={<DecoratorSettings field={field} onUpdateField={onUpdateField} />}
          placement='bottom-start'
          styleType='clear'
          visible={showDecoratorSettings}
        >
          {() => (
            <Tooltip
              overlay={t('elements.simulator.tooltip.decorator')}
              trigger={['hoverWithoutContent']}
            >
              <Button
                active={showDecoratorSettings}
                name='decorator'
                size={KitSize.S}
                styleType='secondary'
              >
                {t('elements.simulator.toolbar.decorator')}
              </Button>
            </Tooltip>
          )}
        </Dropdown>
        <Dropdown
          offset={[12, -6]}
          onVisibleChange={setShowValidationSettings}
          overlay={<ValidationSettings field={field} onUpdateField={onUpdateField} />}
          placement='bottom-start'
          styleType='clear'
          visible={showValidationSettings}
        >
          {() => (
            <Tooltip
              overlay={t('elements.simulator.tooltip.validation')}
              trigger={['hoverWithoutContent']}
            >
              <Button
                active={showValidationSettings}
                name='validation'
                size={KitSize.S}
                styleType='secondary'
              >
                {t('elements.simulator.toolbar.validation')}
              </Button>
            </Tooltip>
          )}
        </Dropdown>
        <Tooltip overlay={t('elements.simulator.tooltip.delete')}>
          <IconButton
            icon='trashDeleteBin'
            iconSize={KitSize.S}
            name='deleteField'
            onClick={onDeleteField}
            size={KitSize.S}
            styleType='ghost'
          />
        </Tooltip>
      </div>
    </AbsolutePortal>
  )
}

export default InputFieldToolbar
